import { render, staticRenderFns } from "./CapturaDocumentoTeste.vue?vue&type=template&id=1ec3e8af&scoped=true&"
import script from "./CapturaDocumentoTeste.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentoTeste.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentoTeste.vue?vue&type=style&index=0&id=1ec3e8af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3e8af",
  null
  
)

export default component.exports